// extracted by mini-css-extract-plugin
export default {"dragBox":"DragNDrop_dragBox__8OarR","dndBox":"DragNDrop_dndBox__6Z0Mu"};